import { CHANGE_LANGUAGE_SUCCESS } from "../types";

const changeLanguage = lang => {
  return {
    type: CHANGE_LANGUAGE_SUCCESS,
    payload: lang
  };
};

export { changeLanguage };
